import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_col = _resolveComponent("van-col");
  const _component_van_row = _resolveComponent("van-row");
  const _component_van_cell = _resolveComponent("van-cell");
  const _component_ListViewCpt = _resolveComponent("ListViewCpt");
  const _component_PageNavBackLayoutCpt = _resolveComponent("PageNavBackLayoutCpt");
  return _openBlock(), _createBlock(_component_PageNavBackLayoutCpt, {
    class: "page"
  }, {
    default: _withCtx(() => [_createVNode(_component_ListViewCpt, {
      ref: "ListViewCpt",
      request: $data.listRequest,
      requestParameter: $data.searchForm
    }, {
      default: _withCtx(({
        item
      }) => [_createVNode(_component_van_cell, {
        title: '拜访时间：' + item.visitTime
      }, {
        label: _withCtx(() => [_createVNode(_component_van_row, {
          gutter: "20"
        }, {
          default: _withCtx(() => [_createVNode(_component_van_col, {
            span: "24"
          }, {
            default: _withCtx(() => [_createTextVNode(" 拜访内容：" + _toDisplayString(item.visitContent || ''), 1)]),
            _: 2
          }, 1024), _createVNode(_component_van_col, {
            span: "12"
          }, {
            default: _withCtx(() => [_createTextVNode("拜访动作：" + _toDisplayString(_ctx.formatSelectColumn($data.codeResItems, 'visitAction', {
              visitType: item.visitType
            })), 1)]),
            _: 2
          }, 1024), _createVNode(_component_van_col, {
            span: "12"
          }, {
            default: _withCtx(() => [_createTextVNode("拜访类型：" + _toDisplayString(_ctx.formatSelectColumn($data.codeResItems, 'visitType', {
              visitType: item.visitType
            })), 1)]),
            _: 2
          }, 1024), item.nextVisitTime ? (_openBlock(), _createBlock(_component_van_col, {
            key: 0,
            span: "24"
          }, {
            default: _withCtx(() => [_createTextVNode(" 下次拜访时间：" + _toDisplayString(item.nextVisitTime), 1)]),
            _: 2
          }, 1024)) : _createCommentVNode("", true)]),
          _: 2
        }, 1024)]),
        _: 2
      }, 1032, ["title"])]),
      _: 1
    }, 8, ["request", "requestParameter"])]),
    _: 1
  });
}